import { makeObservable, observable, action } from 'mobx';
import '../../enums/GameSpecificTypes.js';
import '../../enums/MaxPayoutDataTypes.js';
import '../../enums/Chat.js';
import '../../enums/GameModes.js';
import '../../enums/IconTypes.js';
import '../../enums/BetStatus.js';
import '../../enums/PopupTypes.js';
import '../../enums/ApiVersion.js';
import '../../enums/RoundStatus.js';
import '../../enums/FreeBetsStatus.js';
import '../../enums/SocketEvents.js';
import '../../enums/TranslationKeys.js';
import '../../enums/TimeoutMaxValue.js';
import '../../enums/ApiServiceTypes.js';
import '../../enums/EnvironmentTypes.js';
import '../../enums/DefaultQueryValues.js';
import '../../enums/FreeBetWinningType.js';
import '../../enums/DefaultQueryParams.js';
import '../../enums/BetHistoryFilterTypes.js';
import '../../enums/GameThemeTypes.js';
import '../../enums/RequestStatus.js';
import '../../enums/FetchDefaultPaths.js';
import '../../enums/ResponseCodes.js';
import { betSectionIndex } from '../../enums/BogLineGameConfig.js';

var OddStore = /** @class */ (function () {
    function OddStore() {
        var _a;
        this.oddData = null;
        this.isCrash = null;
        this.isMaxWin = (_a = {},
            _a[betSectionIndex.firstIndex] = null,
            _a[betSectionIndex.secondIndex] = null,
            _a);
        this.isFirstResultReport = true;
        this.isStartInitialOdd = false;
        makeObservable(this, {
            isFirstResultReport: observable,
            isStartInitialOdd: observable,
            oddData: observable,
            isMaxWin: observable.deep,
            isCrash: observable,
            setOddData: action.bound,
            resetOddData: action.bound,
            setIsMaxWin: action.bound,
            setIsFirstResultReport: action.bound,
            setIsStartInitialOdd: action.bound,
            resetAllOddStoreData: action.bound,
            resetMaxWinData: action.bound,
            setIsCrash: action.bound,
        });
    }
    OddStore.prototype.setIsCrash = function (bool) {
        this.isCrash = bool;
    };
    OddStore.prototype.resetAllOddStoreData = function () {
        var _a;
        this.setIsFirstResultReport(true);
        this.setIsStartInitialOdd(false);
        this.resetOddData();
        this.isMaxWin = (_a = {},
            _a[betSectionIndex.firstIndex] = null,
            _a[betSectionIndex.secondIndex] = null,
            _a);
    };
    OddStore.prototype.setIsStartInitialOdd = function (bool) {
        this.isStartInitialOdd = bool;
    };
    OddStore.prototype.setIsFirstResultReport = function (bool) {
        this.isFirstResultReport = bool;
    };
    OddStore.prototype.setOddData = function (odd) {
        this.oddData = odd;
    };
    OddStore.prototype.setIsMaxWin = function (bool, index) {
        this.isMaxWin[index] = bool;
    };
    OddStore.prototype.resetMaxWinData = function () {
        var _a;
        this.isMaxWin = (_a = {},
            _a[betSectionIndex.firstIndex] = null,
            _a[betSectionIndex.secondIndex] = null,
            _a);
    };
    OddStore.prototype.resetOddData = function () {
        'resetOddData';
        this.oddData = null;
    };
    return OddStore;
}());
var oddStore = new OddStore();

export { oddStore };
